function mergeArrays(source, target) {
  let mergedArray = []
  // 合并数组元素
  source.forEach((item, index) => {
    if (target[index] !== undefined) {
      if (typeof item === 'object' && typeof target[index] === 'object') {
        mergedArray.push(mergeObjects(item, target[index]))
      } else {
        mergedArray.push(target[index])
      }
    } else {
      mergedArray.push(item)
    }
  })
  // 添加剩余的 target 数组元素
  for (let i = source.length; i < target.length; i++) {
    mergedArray.push(target[i])
  }
  return mergedArray
}
export function mergeObjects(source, target) {
  if (!target) {
    target = {}
  }
  let merged = {}
  // 合并 source 和 target 中的属性
  for (let key in source) {
    if (source.hasOwnProperty(key)) {
      // 如果 target 中有相同属性
      if (key in target) {
        // 如果属性值为对象，则递归合并
        if (
          typeof source[key] === 'object' &&
          typeof target[key] === 'object' &&
          !Array.isArray(source[key]) &&
          !Array.isArray(target[key])
        ) {
          merged[key] = mergeObjects(source[key], target[key])
        } else if (Array.isArray(source[key]) && Array.isArray(target[key])) {
          // 如果属性值为数组，则合并数组
          merged[key] = mergeArrays(source[key], target[key])
        } else {
          // 否则以 target 中的属性值为准
          merged[key] = target[key]
        }
      } else {
        // 如果 target 中不存在相同属性，则使用 source 中的属性值
        merged[key] = source[key]
      }
    }
  }
  // 添加 target 中额外的属性
  for (let key in target) {
    if (target.hasOwnProperty(key) && !(key in source)) {
      merged[key] = target[key]
    }
  }
  return merged
}



// WEBPACK FOOTER //
// ./src/public/components/kye-report-form/utils/merge.js